<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="showData"
      :loading="loading"
      hide-actions
      class="elevation-1"
    >
      <template #items="props">
        <tr>
          <td>{{ props.item.jamsai_id || '-' }}</td>
          <td>
            {{
              `${props.item.first_name}${props.item.last_name ? ` ${props.item.last_name}` : ''}`
            }}
          </td>
          <td>{{ props.item.app }}</td>
        </tr>
      </template>
    </v-data-table>
    <div class="mt-3 text-xs-center">
      <v-pagination
        v-model="pageNumber"
        :total-visible="6"
        :length="Math.ceil(total / rowPerPage)"
        @input="changePage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import jamsaiApi from '@/api/jamsai'
export default {
  props: ['broadcast_id'],
  data() {
    return {
      //   broadcast: this.value,
      total: 0,
      rowPerPage: 5,
      pageNumber: 1,
      loading: false,
      showData: [],
      headers: [
        { text: 'Jamsai ID', value: 'jamsai_id', sortable: false },
        { text: 'Social Name', value: 'name', sortable: false },
        { text: 'Channel', value: 'app', sortable: false }
      ]
    }
  },
  mounted() {
    this.jamsaiReachBroadCast(this.broadcast_id)
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    changePage(page) {
      this.pageNumber = page
      this.jamsaiReachBroadCast(this.broadcast_id)
    },
    async jamsaiReachBroadCast(broadcast_id) {
      try {
        this.loading = true
        const response = await jamsaiApi.getBroadcastLog({
          page_id: this.selectedBot.pageid,
          boradcast_id: broadcast_id,
          params: {
            limit: this.rowPerPage,
            offset: this.rowPerPage * this.pageNumber - this.rowPerPage
          }
        })
        if (response.data && response.data.data) {
          this.showData = response.data.data
          this.total = response.data.total
        } else {
          this.showData = []
        }
      } catch (error) {
        this.$swal.fire({
          title: 'fail to load broadcast log',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastLog.vue